import { render, staticRenderFns } from "./BarChartView.vue?vue&type=template&id=cc284f48&"
import script from "./BarChartView.vue?vue&type=script&lang=js&"
export * from "./BarChartView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports